import MenuItem, { IMenuItem } from './MenuItem';

interface IOrderHistoryItem extends IMenuItem {
  price: string;
}

class OrderHistoryItem extends MenuItem implements IOrderHistoryItem {
  price: string;

  get servingPrice(): number {
    const { servings } = this.sku;
    const totalServings: number = (servings || 1) * this.quantity;
    const price: number = Number.parseFloat(this.price);

    return price / totalServings;
  }
}

export type { IOrderHistoryItem };
export default OrderHistoryItem;
